module.exports = __webpack_public_path__ + "img/xmasParty18.71d9114c.jpg";